var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_2465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5H4C1.79086 0.5 0 2.29086 0 4.5V16.5C0 18.7091 1.79086 20.5 4 20.5H16C18.2091 20.5 20 18.7091 20 16.5V4.5C20 2.29086 18.2091 0.5 16 0.5Z",
    fill: "#0516C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2403 5.5H7.75956C6.23794 5.5 5 6.738 5 8.25962V12.7403C5 14.262 6.23794 15.4999 7.75956 15.4999H12.2403C13.762 15.4999 14.9999 14.2619 14.9999 12.7403V8.25962C15 6.738 13.762 5.5 12.2403 5.5ZM14.1128 12.7403C14.1128 13.7728 13.2728 14.6127 12.2403 14.6127H7.75956C6.72717 14.6128 5.88724 13.7728 5.88724 12.7403V8.25962C5.88724 7.22723 6.72717 6.38724 7.75956 6.38724H12.2403C13.2727 6.38724 14.1127 7.22723 14.1127 8.25962L14.1128 12.7403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0006 7.92334C8.57973 7.92334 7.42383 9.07924 7.42383 10.5001C7.42383 11.9208 8.57973 13.0767 10.0006 13.0767C11.4214 13.0767 12.5773 11.9208 12.5773 10.5001C12.5773 9.07924 11.4214 7.92334 10.0006 7.92334ZM10.0006 12.1894C9.06902 12.1894 8.31107 11.4316 8.31107 10.5C8.31107 9.56841 9.06896 8.81052 10.0006 8.81052C10.9322 8.81052 11.6901 9.56841 11.6901 10.5C11.6901 11.4316 10.9321 12.1894 10.0006 12.1894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6848 7.1709C12.5139 7.1709 12.346 7.2401 12.2252 7.36136C12.1039 7.48203 12.0342 7.65001 12.0342 7.82154C12.0342 7.99254 12.104 8.16047 12.2252 8.28173C12.3459 8.40239 12.5139 8.47219 12.6848 8.47219C12.8564 8.47219 13.0237 8.40239 13.145 8.28173C13.2663 8.16047 13.3355 7.99249 13.3355 7.82154C13.3355 7.65001 13.2663 7.48203 13.145 7.36136C13.0243 7.2401 12.8564 7.1709 12.6848 7.1709Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_2465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.97512f5d6b68e4efa74ce403a27419a7.svg";
export { ForwardRef as ReactComponent };